import { useQuery } from '@tanstack/react-query';
import { getMenuSuggestions } from '@/lib/api/menus';
import type { MealType } from '@/types/api';

export function useSmartMenuSuggestions(date: string, mealType: MealType) {
  return useQuery({
    queryKey: ['menu-suggestions', date, mealType],
    queryFn: () => getMenuSuggestions(date, mealType),
    // No staleTime - always fetch fresh data
  });
}
